import Switcher from "../../../components/Switcher";
import {DateTime} from "luxon";
import React from "react";
import {CalendarView} from "./EventSchedule";

type DateSelectorProps = {
  calendarView: CalendarView
  selectDate: (date: DateTime) => void
  selectedDate: DateTime
}

function DateSelector({ calendarView, selectDate, selectedDate }: DateSelectorProps) {
  return (
    <>
      {calendarView === 'day' &&
        <Switcher
          text='Today'
          previousText='Previous day'
          nextText='Next day'
          onPress={() => selectDate(DateTime.now())}
          onPressPrevious={() => selectDate(selectedDate.minus({day: 1}))}
          onPressNext={() => selectDate(selectedDate.plus({day: 1}))}
        />
      }

      {calendarView === 'week' &&
        <Switcher
          text='This Week'
          previousText='Previous week'
          nextText='Next week'
          onPress={() => selectDate(DateTime.now())}
          onPressPrevious={() => selectDate(selectedDate.minus({week: 1}))}
          onPressNext={() => selectDate(selectedDate.plus({week: 1}))}
        />
      }

      {calendarView === 'month' &&
        <Switcher
          text='This Month'
          previousText='Previous month'
          nextText='Next month'
          onPress={() => selectDate(DateTime.now())}
          onPressPrevious={() => selectDate(selectedDate.minus({month: 1}))}
          onPressNext={() => selectDate(selectedDate.plus({month: 1}))}
        />
      }
    </>
  )
}

export default DateSelector